
import axios from "axios";
const base_path = window.APP_CONFIG?.BASE_URL;


//signup
// export const addUser = async (objCustomer) => {
//     const response = await axios.post(`${base_path}/Api/Customer/Save`, objCustomer);
//     return response.data;
//   };

  export const getstatesByGuid = async (guid) => {
    const response = await axios.get(
      `${base_path}/Api/state/GetByGuid?guid=${guid}`
    );
   
    return response.data;
  };
  export const getstates = async () => {
    const response = await axios.get(`${base_path}/Api/state/GetAll`);
  
    return response.data;
  };
//get user data
  export const userService = async (userId) => {
    const response = await axios.get(
      `${base_path}/Api/Customer/GetByGuid?guid=${userId}`
    );
    return response.data;
  };
  //get all users
  // export const getUser = async () => {
  //   const response = await axios.get(`${base_path}/Api/User/GetAll`);
  //   return response.data;
  // };

  //login
  export const AuthenticateUser = async (objUser) => {
    var criteriaJsonString = JSON.stringify(objUser);
    const response = await axios.get(
      `${base_path}/Api/Customer/AuthenticateUser?criteria=${criteriaJsonString}`
    );
    return response.data;
  };


  
  export const updateuser = async (formData) => {
    const response = await axios.post(`${base_path}/Api/User/Update`,formData);
    return response.data;
  };

  export const updatecustomer = async (formData) => {
    const response = await axios.post(`${base_path}/Api/Customer/Update`,formData);
    return response.data;
  };
  export const fetchAddress =  async (userId) => {
    const response = await fetch(`${base_path}/${userId}`);
    return response.json();
  };
  

  export const updateAddress = async (updatedAddress) => {
    const response = await fetch(base_path, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(updatedAddress),
    });
    return response.json();
  };

  export const saveCustomerAddress = async (addressObj) => {
    const response = await axios.post(`${base_path}/Api/Customer/Save`, addressObj);
    return response.data;
  };
//create customer
export const addCustomer = async (customerData) => {
  const response = await axios.post(
    `${base_path}/Api/Customer/Save`,
    customerData
  );

  return response;
};

  //get list of customers
export const getCustomersList = async (branch) => {
  const response = await axios.get(
    `${base_path}/Api/Customer/GetAllbyBranch?globalBranchID=${branch?.guid}`
  );

  return response.data;
};



//get customer by guid
export const getCustomerByGuid = async (guid) => {
  const response = await axios.get(
    `${base_path}/Api/Customer/GetByGuid?guid=${guid}`
  );
  return response;
};

//update customer
export const editCustomer = async (customerData) => {
  const response = await axios.post(
    `${base_path}/Api/Customer/Update`,
    customerData
  );
  console.log("Payload being sent to backenddd:", customerData);

  return response;
};

//delete customer
export const deleteCustomer = async (id) => {
  let custId = JSON.stringify(id);
  const response = await axios.post(`${base_path}/Api/Customer/Delete`, custId);

  return response;
};